const DOMAIN_PATTERN = /^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}$/i;

export const looksLikeDomain = (value = "") => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return false;
  const host = trimmed
    .replace(/^https?:\/\//i, "")
    .split("/")[0]
    .split("?")[0]
    .trim();
  return DOMAIN_PATTERN.test(host);
};

export const extractDomain = (value = "") => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  try {
    const withProtocol = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `https://${trimmed}`;
    return new URL(withProtocol).hostname.replace(/^www\./i, "").toLowerCase();
  } catch (error) {
    return "";
  }
};

export const domainToBrandName = (domain = "") => {
  const host = String(domain || "")
    .split(".")[0]
    .replace(/[-_]+/g, " ")
    .trim();
  if (!host) return "";
  return host
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};
